module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "supplier-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "pcsp"
  }, [_c('h1', [_vm._v("Account Information - " + _vm._s(_vm.user.username))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h2', [_vm._v("Basic Information")]), _vm._v(" "), _c('p', [_vm._v("Name: " + _vm._s(_vm.user.name))]), _vm._v(" "), _c('p', [_vm._v("Account-Type: Buyer")]), _vm._v(" "), (!_vm.showpw) ? _c('p', [_vm._v("Password: "), _c('button', {
    staticClass: "button-type-e",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ShowChangePW($event)
      }
    }
  }, [_vm._v("Change")])]) : _vm._e(), _vm._v(" "), (_vm.showpw) ? _c('form', {
    attrs: {
      "id": "changePassword"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.ChangePassword($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "old_pw"
    }
  }, [_vm._v("Enter Old Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "old_pw",
      "id": "old_pw"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "new_pw"
    }
  }, [_vm._v("Enter New Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "new_pw",
      "id": "new_pw"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "confirm_new_pw"
    }
  }, [_vm._v("Confirm New Password")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "confirm_new_pw",
      "id": "confirm_new_pw"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "token"
    },
    domProps: {
      "value": _vm.changepwtoken
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "floatright button-type-e",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h2', [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Email: " + _vm._s(_vm.user.email))]), _vm._v(" "), (!_vm.showmb) ? _c('p', [_vm._v("Mobile #: " + _vm._s(_vm.user.mobile_number) + " "), _c('button', {
    staticClass: "button-type-e",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.ShowChangeMB($event)
      }
    }
  }, [_vm._v("Change")])]) : _vm._e(), _vm._v(" "), (_vm.showmb) ? _c('form', {
    attrs: {
      "id": "changeMobile"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.ChangeMobile($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "new_mb"
    }
  }, [_vm._v("Enter New Mobile Number")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "new_mb",
      "id": "new_mb"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "floatright button-type-e",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])]) : _vm._e()])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.notification) ? _c('div', {
    staticClass: "notification-b"
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.notificationMessage)
    }
  }), _vm._v(" "), _c('span')]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77098822"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserAccount.vue
// module id = 157
// module chunks = 0